export default {
  blizzardId: '',
  sessionToken: '',
  sessionName: '',
  showLoginModal: false,
  newSessionName: '',
  loadSessionInput: '',
};
